export const PROJECTS = {
  '3m': {
    name: '3M',
    prefix: '3m',
    description: 'Proyecto 3M existente',
    hasData: true,
    color: '#3B82F6',
    isActive: true
  },
  'es': {
    name: 'Escucha Sistémica',
    prefix: 'es', 
    description: 'Proyecto Escucha Sistémica',
    hasData: false,
    color: '#10B981',
    isActive: true
  }
} as const;

export type ProjectKey = keyof typeof PROJECTS;

export const DEFAULT_PROJECT: ProjectKey = '3m';

export function getProjectConfig(project: ProjectKey) {
  return PROJECTS[project];
}

export function getAllProjects() {
  return Object.entries(PROJECTS).map(([key, config]) => ({
    key: key as ProjectKey,
    ...config
  }));
}

export function isProjectActive(project: ProjectKey): boolean {
  return PROJECTS[project].isActive;
}
